module.exports = __webpack_public_path__ + "static/img/20_月結帳單.4d95e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/20_月結帳單.png
// module id = bUL+
// module chunks = 1